export default __webpack_public_path__ + "static/media/logo.9ee1b4b4.svg";